<template>
  <base-section id="single-product">
    <base-section-heading>
      <p class="options">
        <span v-for="option in productInfo.options">{{ option }}</span>
      </p>
    </base-section-heading>

    <v-container>
      <v-row align="center" justify="center">
<!--        <v-col cols="12" md="5">-->
<!--          <v-card elevation="16" class="mb-12">-->
<!--            <base-img max-width="100%" :src="require(`@/assets/products/${productInfo.image}`)" />-->
<!--          </v-card>-->
<!--        </v-col>-->

        <v-col cols="12" md="12">
          <div class="description">
            <p v-for="paragraph in productInfo.description">{{ paragraph }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <base-section-heading title="">
      <p class="disclaimer">Технические характеристики оборудования и изделий уточняются при запросе и согласовываются при заказе</p>
      <base-btn :tile="false" color="primary" rounded @click="$router.push({ name: 'Manufacture' })">
        <v-icon right>mdi-arrow-left</v-icon>
        К СПИСКУ ОБУРУДОВАНИЯ
      </base-btn>
    </base-section-heading>
  </base-section>
</template>

<script>
export default {
  name: 'SectionSingleProduct',
  props: {
    productInfo: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.options span {
  &:after {
    content: "\2022";
    color: #42a5f6;
    font-weight: 800;
    padding: 0 10px;
  }
  &:last-child {
    &:after {
      content: "";
    }
  }
}

.mdi-arrow-left {
  padding-right: 20px;
}

.disclaimer {
  font-style: italic;
}
</style>